import React from "react";
import { Box, Button, Typography, Grid } from "@mui/material";
import styled from "styled-components";
import { useState, useEffect } from "react";
import AOS from "aos";
import "@fontsource/great-vibes";
import "@fontsource/raleway";
import { MdPhone, MdEmail } from "react-icons/md";
import { BsGithub, BsFilePdf } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import Drone from "./Drone";
const OpenPDF = () => {
  const url = `https://drive.google.com/file/d/1Eyk7NdQAlS-swQH5K2KalQIa5KJ6yBPB/view?usp=sharing`;

  window.open(url, "_blank");
};

const OpenPDFNew = (url) => {
  window.open(url, "_blank");
};
function DownloadButton({ fileName, fileUrl }) {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button
      onClick={() => {
        handleDownload();
        OpenPDF();
      }}
      variant="contained"
      className="my-typography-button"
      id="resume-button-2"
      style={{
        backgroundColor: "rgb(255, 255, 255)",
        color: "black",
        margin: "2%",
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
      size="medium"
      startIcon={<BsFilePdf />}
      download="Tathagat_Resume.pdf"
    >
      Resume
    </Button>
  );
}
export const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1800,
    });
    AOS.refresh();
  }, []);

  return (
    <div id="about" className="about section nav-link about">
      <Drone />
      <Container>
        <Box sx={{ width: "95%", margin: "auto" }}>
          <Typography
            variant="h4"
            color="black"
            style={{
              fontFamily: "Great Vibes",
              color: "#1b242f",
              display: "inline-block",
              wordSpacing: 0,
            }}
            data-aos="fade-right"
          >
            About <span style={{ color: "#04c998" }}>Me</span>
          </Typography>
          <div
            style={{
              width: "3rem",
              backgroundColor: "#1b242f",
              height: "1vh",
              margin: "auto",
              marginBottom: "2%",
            }}
            data-aos="fade-left"
          ></div>
          <Box sx={{ marginTop: "5%" }}>
            <Grid container spacing={2}>
              <Typography
                id="user-detail-intro"
                variant="body1"
                sx={{
                  textAlign: "left",
                  marginBottom: "1rem",
                  fontFamily: "Raleway",
                }}
              >
                <span style={{ color: "#dc258a" }}>As</span> a proficient
                full-stack web developer, I possess a strong grounding in{" "}
                <b className="yellow">HTML</b>, <b className="yellow">CSS</b>,
                and <b className="yellow">JavaScript</b>, coupled with a
                comprehensive grasp of the MERN stack (
                <b className="yellow">MongoDB</b>,{" "}
                <b className="yellow">Express.js</b>,{" "}
                <b className="yellow">React.js</b>,{" "}
                <b className="yellow">Node.js</b>). I enjoy creating things that
                live on the internet, and I am committed to maintaining an
                up-to-date awareness of the latest advancements and current
                trends in the field. I am also driven to continually expand my
                expertise and proficiency.
                <br />
                <br />
                <span style={{ color: "#dc258a" }}>However,</span> what sets me
                apart is my passion for problem-solving and out-of-the-box
                thinking that I have developed through curated experience. I
                approach each project with an innovative mindset, thriving on
                complex challenges that require creative and dynamic solutions.
                With strong communication skills, attention to detail, and a
                commitment to excellence, I consistently deliver high-quality
                work.
              </Typography>
              <div
                className="hex3"
                data-aos="flip-left"
                style={{
                  margin: "auto",
                  clipPath:
                    "polygon(50% 0%, 87% 25%, 87% 75%, 50% 100%, 13% 75%, 13% 25%)",
                }}
              >
                {" "}
                <img
                  src="./Tathagat3.jpg"
                  style={{ width: "90%", margin: "auto", borderRadius: "60%" }}
                  className="myAvtar home-img"
                ></img>
              </div>
            </Grid>
            <Button
              className="my-typography-button"
              variant="contained"
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "black",
                borderRadius: "10px",
                margin: "2%",
                fontFamily: "Raleway",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
              size="large"
              startIcon={<BsGithub />}
              onClick={() => OpenPDFNew("https://github.com/Tathagat017")}
            >
              Github
            </Button>
            <Button
              className="my-typography-button"
              variant="contained"
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "black",
                borderRadius: "10px",
                margin: "2%",
                fontFamily: "Raleway",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
              size="large"
              startIcon={<FaLinkedin />}
              onClick={() =>
                OpenPDFNew("https://www.linkedin.com/in/tathagat-tathagat/")
              }
            >
              Linkedin
            </Button>
            <Button
              className="my-typography-button"
              variant="contained"
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "black",
                margin: "2%",
                fontFamily: "Raleway",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
              size="large"
              startIcon={<MdEmail />}
              onClick={() =>
                OpenPDFNew(
                  "https://mail.google.com/mail/?view=cm&source=mailto&to=tathagatraj4@gmail.com"
                )
              }
            >
              email
            </Button>
            <DownloadButton
              fileName={"Tathagat-Resume.pdf"}
              fileUrl={"./Tathagat-Resume.pdf"}
            >
              Resume
            </DownloadButton>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

const Container = styled.div`
  width: 100%;
  text-align: center;
  margin: auto;
  margin-bottom: 5%;
  width: 80%;
  @media screen and (min-width: 650px) and (max-width: 836px) {
    #about {
      margin-top: 20%;
    }
    .myAvtar {
      width: 40%; // change the width based on screen size
      margin: auto;
      margin-top: 2%; // change the margin-top based on screen size
    }
  }
  @media screen and (min-width: 500px) and (max-width: 649px) {
    #about {
      margin-top: 20%;
    }
    .myAvtar {
      width: 50%; // change the width based on screen size
      margin: auto;
      margin-top: 2%; // change the margin-top based on screen size
    }
    #desc {
      font-size: 1.1rem;
    }
  }
  @media screen and (min-width: 394px) and (max-width: 499px) {
    #about {
      margin-top: 30%;
    }
    .myAvtar {
      width: 60%; // change the width based on screen size
      margin: auto;
      margin-top: 2%; // change the margin-top based on screen size
    }
    #desc {
      font-size: 3.5vw;
    }
  }
  @media screen and (max-width: 393px) {
    #about {
      margin-top: 45%;
    }
    .myAvtar {
      width: 80%; // change the width based on screen size
      margin: auto;
      margin-top: 2%; // change the margin-top based on screen size
    }
  }
`;
